//TODO: add designs
export const NotFound = () => {
  return <p>Not found</p>;
};
